export default __webpack_public_path__ + "static/rokhzan2019-983086a723e82bf6029704a92d1b3bd8.png";